import { useCookies } from 'react-cookie';

// authentication
export const useAuthCookies = () => {
	const [cookies, setCookie, removeCookie] = useCookies(['AccessToken']);

	const setAccessToken = (token: string) => {
		setCookie('AccessToken', token, { path: '/' });
	};

	const getAccessToken = () => cookies['AccessToken'] || null;

	const removeAccessToken = () => {
		removeCookie('AccessToken', { path: '/' });
	};

	return { setAccessToken, getAccessToken, removeAccessToken };
};
